import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import IncidentType from '@/plugins/sdk/resources/Incident/Type'
import IncidentStatus from '@/plugins/sdk/resources/Incident/Status'
import IncidentPriority from '@/plugins/sdk/resources/Incident/Priority'
import Profile from '@/plugins/sdk/resources/Profile'

export default class extends Resource {
  static name = 'incident'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      type: new ITEM(IncidentType),
      priority: new ITEM(IncidentPriority),
      status: new ITEM(IncidentStatus),
      profile: new ITEM(Profile)
    }
  }
}
